module.exports = __webpack_public_path__ + "static/media/project.ca518f55.jpg";